
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $5525881969d9a665$exports = {};
'use strict';
function $5525881969d9a665$var$FFT(size) {
    this.size = size | 0;
    if (this.size <= 1 || (this.size & this.size - 1) !== 0) throw new Error('FFT size must be a power of two and bigger than 1');
    this._csize = size << 1;
    // NOTE: Use of `var` is intentional for old V8 versions
    var table = new Array(this.size * 2);
    for(var i = 0; i < table.length; i += 2){
        const angle = Math.PI * i / this.size;
        table[i] = Math.cos(angle);
        table[i + 1] = -Math.sin(angle);
    }
    this.table = table;
    // Find size's power of two
    var power = 0;
    for(var t = 1; this.size > t; t <<= 1)power++;
    // Calculate initial step's width:
    //   * If we are full radix-4 - it is 2x smaller to give inital len=8
    //   * Otherwise it is the same as `power` to give len=4
    this._width = power % 2 === 0 ? power - 1 : power;
    // Pre-compute bit-reversal patterns
    this._bitrev = new Array(1 << this._width);
    for(var j = 0; j < this._bitrev.length; j++){
        this._bitrev[j] = 0;
        for(var shift = 0; shift < this._width; shift += 2){
            var revShift = this._width - shift - 2;
            this._bitrev[j] |= (j >>> shift & 3) << revShift;
        }
    }
    this._out = null;
    this._data = null;
    this._inv = 0;
}
$5525881969d9a665$exports = $5525881969d9a665$var$FFT;
$5525881969d9a665$var$FFT.prototype.fromComplexArray = function fromComplexArray(complex, storage) {
    var res = storage || new Array(complex.length >>> 1);
    for(var i = 0; i < complex.length; i += 2)res[i >>> 1] = complex[i];
    return res;
};
$5525881969d9a665$var$FFT.prototype.createComplexArray = function createComplexArray() {
    const res = new Array(this._csize);
    for(var i = 0; i < res.length; i++)res[i] = 0;
    return res;
};
$5525881969d9a665$var$FFT.prototype.toComplexArray = function toComplexArray(input, storage) {
    var res = storage || this.createComplexArray();
    for(var i = 0; i < res.length; i += 2){
        res[i] = input[i >>> 1];
        res[i + 1] = 0;
    }
    return res;
};
$5525881969d9a665$var$FFT.prototype.completeSpectrum = function completeSpectrum(spectrum) {
    var size = this._csize;
    var half = size >>> 1;
    for(var i = 2; i < half; i += 2){
        spectrum[size - i] = spectrum[i];
        spectrum[size - i + 1] = -spectrum[i + 1];
    }
};
$5525881969d9a665$var$FFT.prototype.transform = function transform(out, data) {
    if (out === data) throw new Error('Input and output buffers must be different');
    this._out = out;
    this._data = data;
    this._inv = 0;
    this._transform4();
    this._out = null;
    this._data = null;
};
$5525881969d9a665$var$FFT.prototype.realTransform = function realTransform(out, data) {
    if (out === data) throw new Error('Input and output buffers must be different');
    this._out = out;
    this._data = data;
    this._inv = 0;
    this._realTransform4();
    this._out = null;
    this._data = null;
};
$5525881969d9a665$var$FFT.prototype.inverseTransform = function inverseTransform(out, data) {
    if (out === data) throw new Error('Input and output buffers must be different');
    this._out = out;
    this._data = data;
    this._inv = 1;
    this._transform4();
    for(var i = 0; i < out.length; i++)out[i] /= this.size;
    this._out = null;
    this._data = null;
};
// radix-4 implementation
//
// NOTE: Uses of `var` are intentional for older V8 version that do not
// support both `let compound assignments` and `const phi`
$5525881969d9a665$var$FFT.prototype._transform4 = function _transform4() {
    var out = this._out;
    var size = this._csize;
    // Initial step (permute and transform)
    var width = this._width;
    var step = 1 << width;
    var len = size / step << 1;
    var outOff;
    var t;
    var bitrev = this._bitrev;
    if (len === 4) for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleTransform2(outOff, off, step);
    }
    else // len === 8
    for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleTransform4(outOff, off, step);
    }
    // Loop through steps in decreasing order
    var inv = this._inv ? -1 : 1;
    var table = this.table;
    for(step >>= 2; step >= 2; step >>= 2){
        len = size / step << 1;
        var quarterLen = len >>> 2;
        // Loop through offsets in the data
        for(outOff = 0; outOff < size; outOff += len){
            // Full case
            var limit = outOff + quarterLen;
            for(var i = outOff, k = 0; i < limit; i += 2, k += step){
                const A = i;
                const B = A + quarterLen;
                const C = B + quarterLen;
                const D = C + quarterLen;
                // Original values
                const Ar = out[A];
                const Ai = out[A + 1];
                const Br = out[B];
                const Bi = out[B + 1];
                const Cr = out[C];
                const Ci = out[C + 1];
                const Dr = out[D];
                const Di = out[D + 1];
                // Middle values
                const MAr = Ar;
                const MAi = Ai;
                const tableBr = table[k];
                const tableBi = inv * table[k + 1];
                const MBr = Br * tableBr - Bi * tableBi;
                const MBi = Br * tableBi + Bi * tableBr;
                const tableCr = table[2 * k];
                const tableCi = inv * table[2 * k + 1];
                const MCr = Cr * tableCr - Ci * tableCi;
                const MCi = Cr * tableCi + Ci * tableCr;
                const tableDr = table[3 * k];
                const tableDi = inv * table[3 * k + 1];
                const MDr = Dr * tableDr - Di * tableDi;
                const MDi = Dr * tableDi + Di * tableDr;
                // Pre-Final values
                const T0r = MAr + MCr;
                const T0i = MAi + MCi;
                const T1r = MAr - MCr;
                const T1i = MAi - MCi;
                const T2r = MBr + MDr;
                const T2i = MBi + MDi;
                const T3r = inv * (MBr - MDr);
                const T3i = inv * (MBi - MDi);
                // Final values
                const FAr = T0r + T2r;
                const FAi = T0i + T2i;
                const FCr = T0r - T2r;
                const FCi = T0i - T2i;
                const FBr = T1r + T3i;
                const FBi = T1i - T3r;
                const FDr = T1r - T3i;
                const FDi = T1i + T3r;
                out[A] = FAr;
                out[A + 1] = FAi;
                out[B] = FBr;
                out[B + 1] = FBi;
                out[C] = FCr;
                out[C + 1] = FCi;
                out[D] = FDr;
                out[D + 1] = FDi;
            }
        }
    }
};
// radix-2 implementation
//
// NOTE: Only called for len=4
$5525881969d9a665$var$FFT.prototype._singleTransform2 = function _singleTransform2(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const evenR = data[off];
    const evenI = data[off + 1];
    const oddR = data[off + step];
    const oddI = data[off + step + 1];
    const leftR = evenR + oddR;
    const leftI = evenI + oddI;
    const rightR = evenR - oddR;
    const rightI = evenI - oddI;
    out[outOff] = leftR;
    out[outOff + 1] = leftI;
    out[outOff + 2] = rightR;
    out[outOff + 3] = rightI;
};
// radix-4
//
// NOTE: Only called for len=8
$5525881969d9a665$var$FFT.prototype._singleTransform4 = function _singleTransform4(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const inv = this._inv ? -1 : 1;
    const step2 = step * 2;
    const step3 = step * 3;
    // Original values
    const Ar = data[off];
    const Ai = data[off + 1];
    const Br = data[off + step];
    const Bi = data[off + step + 1];
    const Cr = data[off + step2];
    const Ci = data[off + step2 + 1];
    const Dr = data[off + step3];
    const Di = data[off + step3 + 1];
    // Pre-Final values
    const T0r = Ar + Cr;
    const T0i = Ai + Ci;
    const T1r = Ar - Cr;
    const T1i = Ai - Ci;
    const T2r = Br + Dr;
    const T2i = Bi + Di;
    const T3r = inv * (Br - Dr);
    const T3i = inv * (Bi - Di);
    // Final values
    const FAr = T0r + T2r;
    const FAi = T0i + T2i;
    const FBr = T1r + T3i;
    const FBi = T1i - T3r;
    const FCr = T0r - T2r;
    const FCi = T0i - T2i;
    const FDr = T1r - T3i;
    const FDi = T1i + T3r;
    out[outOff] = FAr;
    out[outOff + 1] = FAi;
    out[outOff + 2] = FBr;
    out[outOff + 3] = FBi;
    out[outOff + 4] = FCr;
    out[outOff + 5] = FCi;
    out[outOff + 6] = FDr;
    out[outOff + 7] = FDi;
};
// Real input radix-4 implementation
$5525881969d9a665$var$FFT.prototype._realTransform4 = function _realTransform4() {
    var out = this._out;
    var size = this._csize;
    // Initial step (permute and transform)
    var width = this._width;
    var step = 1 << width;
    var len = size / step << 1;
    var outOff;
    var t;
    var bitrev = this._bitrev;
    if (len === 4) for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleRealTransform2(outOff, off >>> 1, step >>> 1);
    }
    else // len === 8
    for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleRealTransform4(outOff, off >>> 1, step >>> 1);
    }
    // Loop through steps in decreasing order
    var inv = this._inv ? -1 : 1;
    var table = this.table;
    for(step >>= 2; step >= 2; step >>= 2){
        len = size / step << 1;
        var halfLen = len >>> 1;
        var quarterLen = halfLen >>> 1;
        var hquarterLen = quarterLen >>> 1;
        // Loop through offsets in the data
        for(outOff = 0; outOff < size; outOff += len)for(var i = 0, k = 0; i <= hquarterLen; i += 2, k += step){
            var A = outOff + i;
            var B = A + quarterLen;
            var C = B + quarterLen;
            var D = C + quarterLen;
            // Original values
            var Ar = out[A];
            var Ai = out[A + 1];
            var Br = out[B];
            var Bi = out[B + 1];
            var Cr = out[C];
            var Ci = out[C + 1];
            var Dr = out[D];
            var Di = out[D + 1];
            // Middle values
            var MAr = Ar;
            var MAi = Ai;
            var tableBr = table[k];
            var tableBi = inv * table[k + 1];
            var MBr = Br * tableBr - Bi * tableBi;
            var MBi = Br * tableBi + Bi * tableBr;
            var tableCr = table[2 * k];
            var tableCi = inv * table[2 * k + 1];
            var MCr = Cr * tableCr - Ci * tableCi;
            var MCi = Cr * tableCi + Ci * tableCr;
            var tableDr = table[3 * k];
            var tableDi = inv * table[3 * k + 1];
            var MDr = Dr * tableDr - Di * tableDi;
            var MDi = Dr * tableDi + Di * tableDr;
            // Pre-Final values
            var T0r = MAr + MCr;
            var T0i = MAi + MCi;
            var T1r = MAr - MCr;
            var T1i = MAi - MCi;
            var T2r = MBr + MDr;
            var T2i = MBi + MDi;
            var T3r = inv * (MBr - MDr);
            var T3i = inv * (MBi - MDi);
            // Final values
            var FAr = T0r + T2r;
            var FAi = T0i + T2i;
            var FBr = T1r + T3i;
            var FBi = T1i - T3r;
            out[A] = FAr;
            out[A + 1] = FAi;
            out[B] = FBr;
            out[B + 1] = FBi;
            // Output final middle point
            if (i === 0) {
                var FCr = T0r - T2r;
                var FCi = T0i - T2i;
                out[C] = FCr;
                out[C + 1] = FCi;
                continue;
            }
            // Do not overwrite ourselves
            if (i === hquarterLen) continue;
            // In the flipped case:
            // MAi = -MAi
            // MBr=-MBi, MBi=-MBr
            // MCr=-MCr
            // MDr=MDi, MDi=MDr
            var ST0r = T1r;
            var ST0i = -T1i;
            var ST1r = T0r;
            var ST1i = -T0i;
            var ST2r = -inv * T3i;
            var ST2i = -inv * T3r;
            var ST3r = -inv * T2i;
            var ST3i = -inv * T2r;
            var SFAr = ST0r + ST2r;
            var SFAi = ST0i + ST2i;
            var SFBr = ST1r + ST3i;
            var SFBi = ST1i - ST3r;
            var SA = outOff + quarterLen - i;
            var SB = outOff + halfLen - i;
            out[SA] = SFAr;
            out[SA + 1] = SFAi;
            out[SB] = SFBr;
            out[SB + 1] = SFBi;
        }
    }
};
// radix-2 implementation
//
// NOTE: Only called for len=4
$5525881969d9a665$var$FFT.prototype._singleRealTransform2 = function _singleRealTransform2(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const evenR = data[off];
    const oddR = data[off + step];
    const leftR = evenR + oddR;
    const rightR = evenR - oddR;
    out[outOff] = leftR;
    out[outOff + 1] = 0;
    out[outOff + 2] = rightR;
    out[outOff + 3] = 0;
};
// radix-4
//
// NOTE: Only called for len=8
$5525881969d9a665$var$FFT.prototype._singleRealTransform4 = function _singleRealTransform4(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const inv = this._inv ? -1 : 1;
    const step2 = step * 2;
    const step3 = step * 3;
    // Original values
    const Ar = data[off];
    const Br = data[off + step];
    const Cr = data[off + step2];
    const Dr = data[off + step3];
    // Pre-Final values
    const T0r = Ar + Cr;
    const T1r = Ar - Cr;
    const T2r = Br + Dr;
    const T3r = inv * (Br - Dr);
    // Final values
    const FAr = T0r + T2r;
    const FBr = T1r;
    const FBi = -T3r;
    const FCr = T0r - T2r;
    const FDr = T1r;
    const FDi = T3r;
    out[outOff] = FAr;
    out[outOff + 1] = 0;
    out[outOff + 2] = FBr;
    out[outOff + 3] = FBi;
    out[outOff + 4] = FCr;
    out[outOff + 5] = 0;
    out[outOff + 6] = FDr;
    out[outOff + 7] = FDi;
};


class $b4e14b6b8da86996$var$Xy {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
}
class $b4e14b6b8da86996$var$Line extends $b4e14b6b8da86996$var$Xy {
}
class $b4e14b6b8da86996$var$PointSegment extends $b4e14b6b8da86996$var$Xy {
    constructor(x, y, segmentLength){
        super(x, y), this.x = x, this.y = y, this.segmentLength = segmentLength;
    }
}
class $b4e14b6b8da86996$var$Component {
    constructor(frequency, magnitude, phase){
        this.frequency = frequency;
        this.magnitude = magnitude;
        this.phase = phase;
    }
}
class $b4e14b6b8da86996$var$ParametersManager {
    constructor(parameter = 0, complexity = 0, circles = false, hasCapture = false, isMobile = /Mobi|Android/i.test(navigator.userAgent), cores = navigator.hardwareConcurrency ?? 8){
        this.parameter = parameter;
        this.complexity = complexity;
        this.circles = circles;
        this.hasCapture = hasCapture;
        this.isMobile = isMobile;
        this.cores = cores;
    }
    advisedFft() {
        return this.isMobile ? 1024 : this.cores <= 4 ? 2048 : 4096;
    }
}
class $b4e14b6b8da86996$var$FftManager {
    get fftSize() {
        return this._fftSize;
    }
    get fftUnderSize() {
        return this._fftUnderSize.toString();
    }
    constructor(fftSize){
        this._fftSize = $b4e14b6b8da86996$var$parametersManager.advisedFft();
        this.min = 2;
        this.max = 65536;
        this._fftUnderSize = this.fftSize - 1;
        this.fft = new (0, (/*@__PURE__*/$parcel$interopDefault($5525881969d9a665$exports)))(this.fftSize);
        this.input = [];
        this.output = [];
        this.lastChange = performance.now();
        this.changeFftSize(fftSize);
    }
    changeFftSize(fftSize) {
        // console.log('Changing FFT size to', fftSize);
        this._fftSize = fftSize;
        this._fftUnderSize = fftSize - 1;
        this.fft = new (0, (/*@__PURE__*/$parcel$interopDefault($5525881969d9a665$exports)))(fftSize);
        this.input = this.fft.createComplexArray();
        this.output = this.fft.createComplexArray();
        this.lastChange = performance.now();
    }
    computeFft(points) {
        this.samplePathIntoInput(points);
        this.transform();
        this.calculateSortedComponentsFromOutput();
    }
    samplePathIntoInput(points) {
        const startAndEndPoint = points[points.length - 1];
        const closedLength = $b4e14b6b8da86996$var$componentsManager.unclosedLength + startAndEndPoint.segmentLength;
        let lengthIncludingSegment = 0;
        let previousPoint = startAndEndPoint;
        let segmentStartSample = 0;
        for(let i = 0; i < points.length; i++){
            const point = points[i];
            lengthIncludingSegment += point.segmentLength;
            const segmentEndSample = Math.round(this.fftSize * lengthIncludingSegment / closedLength);
            const segmentSampleLength = segmentEndSample - segmentStartSample + 1;
            for(let s = segmentStartSample; s < segmentEndSample; s++){
                const t = (s - segmentStartSample) / segmentSampleLength;
                this.input[2 * s] = $b4e14b6b8da86996$var$lerp(previousPoint.x, point.x, t);
                this.input[2 * s + 1] = $b4e14b6b8da86996$var$lerp(previousPoint.y, point.y, t);
            }
            previousPoint = point;
            segmentStartSample = segmentEndSample;
        }
    }
    transform() {
        this.fft.transform(this.output, this.input);
    }
    calculateSortedComponentsFromOutput() {
        $b4e14b6b8da86996$var$componentsManager.spliceComponents();
        for(let i = 0; i < this.fftSize; i++){
            const x = this.output[2 * i], y = this.output[2 * i + 1];
            $b4e14b6b8da86996$var$componentsManager.pushComponent({
                frequency: i < this.fftSize / 2 ? i : i - this.fftSize,
                magnitude: $b4e14b6b8da86996$var$magnitude(x, y) / this.fftSize,
                phase: Math.atan2(y, x)
            });
        }
        $b4e14b6b8da86996$var$componentsManager.components.sort((a, b)=>b.magnitude - a.magnitude);
    }
    adaptFft(dt) {
        if (performance.now() - this.lastChange < 256) return 0;
        else if (dt > 256 && this._fftSize > this.min) return -2;
        else if (dt >= 28 && this._fftSize > this.min) return -1;
        else if (dt < 6 && this._fftSize < this.max) return 1;
        else return 0;
    }
}
class $b4e14b6b8da86996$var$ComponentsManager {
    clear() {
        this.splicePoints();
        this.unclosedLength = 0;
        this.unclosedPath = new Path2D();
        this.spliceComponents();
    }
    spliceComponents() {
        $b4e14b6b8da86996$var$splice(this.components);
    }
    splicePoints() {
        $b4e14b6b8da86996$var$splice(this.points);
    }
    spliceLines() {
        $b4e14b6b8da86996$var$splice(this.lines);
    }
    pushComponent(component) {
        $b4e14b6b8da86996$var$push(this.components, component);
    }
    pushLine(line) {
        $b4e14b6b8da86996$var$push(this.lines, line);
    }
    pushPoint(point) {
        $b4e14b6b8da86996$var$push(this.points, point);
    }
    setPointSegment(point, x, y) {
        point.segmentLength = $b4e14b6b8da86996$var$magnitude(point.x - x, point.y - y);
    }
    addPoint(x, y) {
        if (this.points.length === 0) this.pushPoint({
            x: x,
            y: y,
            segmentLength: 0
        });
        else {
            const previousPoint = this.points[Math.max(0, this.points.length - 2)];
            const segmentLength = $b4e14b6b8da86996$var$magnitude(x - previousPoint.x, y - previousPoint.y);
            this.unclosedLength += segmentLength;
            this.points.splice(this.points.length - 1, 0, {
                x: x,
                y: y,
                segmentLength: segmentLength
            });
            this.setPointSegment(this.points[this.points.length - 1], x, y);
        }
        this.unclosedPath.lineTo(x, y);
        if (this.unclosedLength > 0) $b4e14b6b8da86996$var$fftManager.computeFft(this.points);
        else this.spliceComponents();
    }
    setPointsLocation() {
        if ($b4e14b6b8da86996$var$componentsManager.points.length <= 0) return null;
        const maxI = Math.min(4096, this.points.length);
        const nbFloat32 = 2, view = new Float32Array(maxI * nbFloat32);
        const lastPt = this.points[this.points.length - 1], scaleI = this.points.length / maxI;
        let i = 0;
        view[i] = lastPt.x; // Starting by the last point (to close the loop)
        view[i + 1] = lastPt.y;
        for(i = 1; i <= maxI; i++){
            const h = i - 1, j = i * nbFloat32, pt = this.points[Math.floor(h * scaleI)];
            view[j] = pt.x;
            view[j + 1] = pt.y;
        }
        return '&pt=' + $b4e14b6b8da86996$var$base64UrlEncode(view.buffer);
    }
    setComponentsLocation() {
        if (this.components.length <= 0) return null;
        const maxI = Math.min(4096, this.components.length - 1);
        const nbFloat32 = 3, view = new Float32Array(maxI * nbFloat32);
        this.components.forEach((cp, i)=>{
            const j = i * nbFloat32;
            view[j] = cp.frequency;
            view[j + 1] = cp.magnitude;
            view[j + 2] = cp.phase;
        });
        return '&cp=' + $b4e14b6b8da86996$var$base64UrlEncode(view.buffer);
    }
    constructor(){
        this.components = [];
        this.lines = [];
        this.points = [];
        this.unclosedLength = 0;
        this.unclosedPath = new Path2D();
    }
}
const $b4e14b6b8da86996$var$canvas = document.getElementById('canvas');
const $b4e14b6b8da86996$var$context = $b4e14b6b8da86996$var$canvas.getContext('2d');
const $b4e14b6b8da86996$var$parametersManager = new $b4e14b6b8da86996$var$ParametersManager();
const $b4e14b6b8da86996$var$fftManager = new $b4e14b6b8da86996$var$FftManager($b4e14b6b8da86996$var$parametersManager.advisedFft());
const $b4e14b6b8da86996$var$componentsManager = new $b4e14b6b8da86996$var$ComponentsManager();
const $b4e14b6b8da86996$var$parameterSlider = document.getElementById('parameter-slider');
$b4e14b6b8da86996$var$parameterSlider.oninput = function() {
    $b4e14b6b8da86996$var$parametersManager.parameter = $b4e14b6b8da86996$var$parameterSlider.valueAsNumber;
    $b4e14b6b8da86996$var$redraw();
};
const $b4e14b6b8da86996$var$complexityNumber = document.getElementById('complexity-number');
$b4e14b6b8da86996$var$complexityNumber.oninput = function() {
    $b4e14b6b8da86996$var$parametersManager.complexity = $b4e14b6b8da86996$var$complexityNumber.valueAsNumber;
    $b4e14b6b8da86996$var$redraw();
};
const $b4e14b6b8da86996$var$complexityCircles = document.getElementById('complexity-circles-check');
$b4e14b6b8da86996$var$complexityCircles.oninput = function() {
    $b4e14b6b8da86996$var$parametersManager.circles = $b4e14b6b8da86996$var$complexityCircles.checked;
    $b4e14b6b8da86996$var$redraw();
};
function $b4e14b6b8da86996$var$updateCanvasSize() {
    $b4e14b6b8da86996$var$canvas.width = window.devicePixelRatio * $b4e14b6b8da86996$var$canvas.clientWidth;
    $b4e14b6b8da86996$var$canvas.height = window.devicePixelRatio * $b4e14b6b8da86996$var$canvas.clientHeight;
}
function $b4e14b6b8da86996$var$loadLocation() {
    window.location.search?.substring(1).split('&').forEach((item)=>{
        switch(item){
            case 'circles':
                $b4e14b6b8da86996$var$complexityCircles.checked = true;
                break;
            default:
                {
                    const [k, v] = item.split('=');
                    if (v === null) return; // Restriction to valued keys
                    const w = v && decodeURIComponent(v);
                    switch(k){
                        case 'pt':
                            {
                                const view = new Float32Array($b4e14b6b8da86996$var$base64UrlDecode(w));
                                for(let i = 0; i < view.length;)$b4e14b6b8da86996$var$componentsManager.addPoint(view[i++], view[i++]);
                                break;
                            }
                        case 'range':
                            $b4e14b6b8da86996$var$parameterSlider.value = w;
                            break;
                        case 'circles':
                            $b4e14b6b8da86996$var$complexityCircles.checked = Boolean(Number(w));
                            break;
                        case 'complexity':
                            $b4e14b6b8da86996$var$complexityNumber.value = w;
                            break;
                        case 'fftsize':
                            $b4e14b6b8da86996$var$fftManager.changeFftSize(Number(w));
                            break;
                        case 'cp':
                            {
                                const view = new Float32Array($b4e14b6b8da86996$var$base64UrlDecode(w));
                                for(let i = 0; i < view.length;)$b4e14b6b8da86996$var$componentsManager.pushComponent({
                                    frequency: view[i++],
                                    magnitude: view[i++],
                                    phase: view[i++]
                                });
                                break;
                            }
                    }
                }
                break;
        }
    });
}
function $b4e14b6b8da86996$var$setPointsLocation() {
    $b4e14b6b8da86996$var$setLocation($b4e14b6b8da86996$var$componentsManager.setPointsLocation());
}
function $b4e14b6b8da86996$var$setComponentsLocation() {
    $b4e14b6b8da86996$var$setLocation($b4e14b6b8da86996$var$componentsManager.setComponentsLocation());
}
function $b4e14b6b8da86996$var$setLocation(complement) {
    if (complement === null) return;
    const newRelativePathQuery = window.location.pathname + '?' + 'range=' + $b4e14b6b8da86996$var$parametersManager.parameter + '&' + 'complexity=' + $b4e14b6b8da86996$var$parametersManager.complexity + '&' + 'circles=' + Number($b4e14b6b8da86996$var$parametersManager.circles) + complement;
    history.pushState(null, '', newRelativePathQuery);
}
function $b4e14b6b8da86996$var$base64UrlEncode(buffer) {
    return new Uint8Array(buffer).toBase64({
        alphabet: 'base64url',
        omitPadding: true
    });
}
function $b4e14b6b8da86996$var$base64UrlDecode(str) {
    return Uint8Array.fromBase64(str, {
        alphabet: 'base64url'
    }).buffer;
}
function $b4e14b6b8da86996$var$initControls() {
    const fftUnderSize = $b4e14b6b8da86996$var$fftManager.fftUnderSize;
    $b4e14b6b8da86996$var$parameterSlider.max = fftUnderSize;
    $b4e14b6b8da86996$var$parametersManager.parameter = $b4e14b6b8da86996$var$parameterSlider.valueAsNumber;
    $b4e14b6b8da86996$var$complexityNumber.max = fftUnderSize;
    $b4e14b6b8da86996$var$parametersManager.complexity = $b4e14b6b8da86996$var$complexityNumber.valueAsNumber;
}
window.addEventListener('resize', function() {
    $b4e14b6b8da86996$var$updateCanvasSize();
    $b4e14b6b8da86996$var$redraw();
});
$b4e14b6b8da86996$var$updateCanvasSize();
$b4e14b6b8da86996$var$loadLocation();
$b4e14b6b8da86996$var$initControls();
$b4e14b6b8da86996$var$parametersManager.circles = $b4e14b6b8da86996$var$complexityCircles.checked;
$b4e14b6b8da86996$var$redraw();
$b4e14b6b8da86996$var$canvas.onpointerdown = function(e) {
    if (e.button === 0) {
        $b4e14b6b8da86996$var$parametersManager.hasCapture = true;
        $b4e14b6b8da86996$var$canvas.setPointerCapture(e.pointerId);
        $b4e14b6b8da86996$var$addPoint(e.offsetX, e.offsetY);
    }
};
$b4e14b6b8da86996$var$canvas.ontouchstart = $b4e14b6b8da86996$var$canvas.ontouchmove = function(e) {
    if (e.touches.length === 1) e.preventDefault();
};
$b4e14b6b8da86996$var$canvas.onpointermove = function(e) {
    if ($b4e14b6b8da86996$var$parametersManager.hasCapture) $b4e14b6b8da86996$var$addPoint(e.offsetX, e.offsetY);
};
$b4e14b6b8da86996$var$canvas.onpointerup = function(e) {
    if ($b4e14b6b8da86996$var$parametersManager.hasCapture) {
        $b4e14b6b8da86996$var$parametersManager.hasCapture = false;
        $b4e14b6b8da86996$var$canvas.releasePointerCapture(e.pointerId);
    }
};
document.getElementById('clear-button').onclick = function() {
    $b4e14b6b8da86996$var$componentsManager.clear();
    $b4e14b6b8da86996$var$redraw();
};
document.getElementById('save-points-button').onclick = ()=>$b4e14b6b8da86996$var$setPointsLocation();
document.getElementById('save-components-button').onclick = ()=>$b4e14b6b8da86996$var$setComponentsLocation();
function $b4e14b6b8da86996$var$push(collection, element) {
    return collection.push(element);
}
function $b4e14b6b8da86996$var$splice(collection) {
    return collection.splice(0, collection.length);
}
function $b4e14b6b8da86996$var$magnitude(x, y) {
    return Math.sqrt(x * x + y * y);
}
function $b4e14b6b8da86996$var$lerp(first, second, t) {
    return first + (second - first) * t;
}
function $b4e14b6b8da86996$var$addPoint(x, y) {
    // Thanks Copilot for this perf measure + shift idea.
    const t0 = performance.now();
    $b4e14b6b8da86996$var$componentsManager.addPoint(x, y);
    $b4e14b6b8da86996$var$redraw();
    const dt = performance.now() - t0;
    const changeFft = $b4e14b6b8da86996$var$fftManager.adaptFft(dt);
    // console.log('FFT adapt:', { dt, changeFft, fftSize: fftManager.fftSize });
    if (changeFft) {
        $b4e14b6b8da86996$var$fftManager.changeFftSize(changeFft > 0 ? $b4e14b6b8da86996$var$fftManager.fftSize << changeFft : $b4e14b6b8da86996$var$fftManager.fftSize >> -changeFft);
        $b4e14b6b8da86996$var$initControls();
    }
}
function $b4e14b6b8da86996$var$redraw() {
    $b4e14b6b8da86996$var$context.setTransform(window.devicePixelRatio, 0, 0, window.devicePixelRatio, 0, 0);
    $b4e14b6b8da86996$var$context.clearRect(0, 0, $b4e14b6b8da86996$var$canvas.clientWidth, $b4e14b6b8da86996$var$canvas.clientHeight);
    if ($b4e14b6b8da86996$var$componentsManager.unclosedLength > 0) {
        const closedPath = new Path2D($b4e14b6b8da86996$var$componentsManager.unclosedPath);
        closedPath.closePath();
        $b4e14b6b8da86996$var$context.strokeStyle = 'black';
        $b4e14b6b8da86996$var$context.stroke(closedPath);
    }
    if ($b4e14b6b8da86996$var$componentsManager.components.length > 0) {
        const maxI = Math.min($b4e14b6b8da86996$var$componentsManager.components.length, $b4e14b6b8da86996$var$parametersManager.complexity <= 0 ? $b4e14b6b8da86996$var$componentsManager.components.length : $b4e14b6b8da86996$var$parametersManager.complexity + 1), pi2 = 2 * Math.PI, p = $b4e14b6b8da86996$var$parametersManager.parameter * pi2 / $b4e14b6b8da86996$var$fftManager.fftSize, _x = 0, _y = 0;
        if ($b4e14b6b8da86996$var$parametersManager.circles) {
            let x = _x, y = _y;
            $b4e14b6b8da86996$var$context.beginPath();
            for(let i = 0; i < maxI; i++){
                const component = $b4e14b6b8da86996$var$componentsManager.components[i];
                const angle = p * component.frequency + component.phase;
                const newX = x + component.magnitude * Math.cos(angle);
                const newY = y + component.magnitude * Math.sin(angle);
                if (i >= 1) {
                    const ray = Math.sqrt(Math.pow(newX - x, 2) + Math.pow(newY - y, 2));
                    $b4e14b6b8da86996$var$context.moveTo(x, y); // Move to the center, drawing a line to the right most circle point (0°)
                    $b4e14b6b8da86996$var$context.arc(x, y, ray, 0, pi2); // Draw the circle starting from 0 rad (0°) to 2*PI rad (360°)
                // context.arc do take the x-rightmost point as 0rad, and pathes cursor from the previous position to the modulated position of the center+ray distance circle.
                // context.arc(A, B, Math.Pi, 2 * Math.Pi) will draw a top-half circle (having it's center on [A, B]), with a line reaching [A, B] if the cursor was not already on this position.
                // ^ There is no use to begin circles from the [newX, newY] point, as it'd still require the ray calculation, and introduces a new angle -> angle + 2*PI calculation.
                } else $b4e14b6b8da86996$var$componentsManager.spliceLines(); // Reset lines
                $b4e14b6b8da86996$var$componentsManager.pushLine({
                    x: newX,
                    y: newY
                }); // Draw the line starting from old to new coords
                x = newX;
                y = newY;
            }
            $b4e14b6b8da86996$var$context.strokeStyle = 'burlywood';
            $b4e14b6b8da86996$var$context.stroke();
            $b4e14b6b8da86996$var$context.beginPath();
            const firstLine = $b4e14b6b8da86996$var$componentsManager.lines[0];
            $b4e14b6b8da86996$var$context.moveTo(firstLine.x, firstLine.y);
            for(let i = 1; i < $b4e14b6b8da86996$var$componentsManager.lines.length; i++){
                const line = $b4e14b6b8da86996$var$componentsManager.lines[i];
                $b4e14b6b8da86996$var$context.lineTo(line.x, line.y);
            }
            $b4e14b6b8da86996$var$context.strokeStyle = 'red';
            $b4e14b6b8da86996$var$context.stroke();
            $b4e14b6b8da86996$var$componentsManager.spliceLines(); // Reset lines
        } else {
            $b4e14b6b8da86996$var$context.beginPath();
            drawComponentsLineIn(maxI, p, _x, _y);
            $b4e14b6b8da86996$var$context.strokeStyle = 'red';
            $b4e14b6b8da86996$var$context.stroke();
        }
        if ($b4e14b6b8da86996$var$parametersManager.complexity > 0) {
            $b4e14b6b8da86996$var$context.beginPath();
            for(let cp = 0; cp < $b4e14b6b8da86996$var$fftManager.fftSize; cp++)drawComponentsLineOut(maxI, cp * pi2 / $b4e14b6b8da86996$var$fftManager.fftSize, _x, _y);
            drawComponentsLineOut(maxI, 0, _x, _y); // End loop
            $b4e14b6b8da86996$var$context.strokeStyle = 'green';
            $b4e14b6b8da86996$var$context.stroke();
        }
    }
    function drawComponentsLineIn(maxI, p, x, y) {
        for(let i = 0; i < maxI; i++){
            const component = $b4e14b6b8da86996$var$componentsManager.components[i];
            const angle = p * component.frequency + component.phase;
            x += component.magnitude * Math.cos(angle);
            y += component.magnitude * Math.sin(angle);
            $b4e14b6b8da86996$var$context.lineTo(x, y);
        }
    }
    function drawComponentsLineOut(maxI, p, x, y) {
        for(let i = 0; i < maxI; i++){
            const component = $b4e14b6b8da86996$var$componentsManager.components[i];
            const angle = p * component.frequency + component.phase;
            x += component.magnitude * Math.cos(angle);
            y += component.magnitude * Math.sin(angle);
        }
        $b4e14b6b8da86996$var$context.lineTo(x, y);
    }
}


//# sourceMappingURL=epic.a4fbd506.js.map
